import { actions as coreActions } from '@elab/core/store/core';

export const COMPONENT_CONNECT = 'COMPONENT_CONNECT';
export const COMPONENT_DISCONNECT = 'COMPONENT_DISCONNECT';

export const createDispatcher = (
    { storeName, reducers, sagaFactory, additionalEvents = {}, initAction },
    dispatch,
) => ({
    COMPONENT_CONNECT: () => {
        dispatch(coreActions.addReducer(storeName, reducers));
        dispatch(coreActions.addSaga(storeName, sagaFactory(), initAction));
    },
    COMPONENT_DISCONNECT: () => {
        dispatch(coreActions.removeSaga(storeName));
        dispatch(coreActions.removeReducer(storeName));
    },
    ...additionalEvents,
});
